import { IContact, TContactForm, TContactFormKeys } from 'clickNgo/entities/contact'

import { IContactCreatorSettingsForm } from './models'
import { CONTACT_CREATOR_TRANSLATION_KEY } from './translation'

/* ----------------------- Enums ------------------------ */

export enum ContactCreatorFormKeys {
  General = 'contact-creator-general',
  HPRoles = 'contact-creator-hp_roles',
  Common = 'contact-creator-common',
  Additional = 'contact-creator-additional',
  Settings = 'contact-creator-settings',
}

export enum ContactCreatorSteps {
  General = 'contact-creator-general-step',
  Common = 'contact-creator-common-step',
  Additional = 'contact-creator-additional-step',
  HPRoles = 'contact-creator-hp_roles-step',
  Review = 'contact-creator-review-step',
}

/* ----------------------- Data ------------------------ */

export const CONTACT_CREATOR_FORM_KEYS: TContactFormKeys = {
  general: ContactCreatorFormKeys.General,
  hpRoles: ContactCreatorFormKeys.HPRoles,
  common: ContactCreatorFormKeys.Common,
  additional: ContactCreatorFormKeys.Additional,
  settings: ContactCreatorFormKeys.Settings,
}

export const CreateContactFormContent: TContactForm<
  IContactCreatorSettingsForm &
    Pick<IContact, 'contactId' | 'partnerId' | 'locationId' | 'hpRoles' | 'communicationName'>
> = {
  titles: {},
  fields: {
    contactId: {
      field: 'contactId',
      label: `${CONTACT_CREATOR_TRANSLATION_KEY}-field-contact_id`,
    },
    communicationName: {
      field: 'communicationName',
      label: `${CONTACT_CREATOR_TRANSLATION_KEY}-field-communication_name`,
    },
    partnerId: {
      field: 'partnerId',
      label: `${CONTACT_CREATOR_TRANSLATION_KEY}-field-partner_id`,
    },
    locationId: {
      field: 'locationId',
      label: `${CONTACT_CREATOR_TRANSLATION_KEY}-field-location_id`,
    },
    hpRoles: {
      field: 'hpRoles',
      label: `${CONTACT_CREATOR_TRANSLATION_KEY}-field-hp_roles`,
    },
    duplicateHPRoles: {
      field: 'duplicateHPRoles',
      label: '',
    },
    actualData: {
      field: 'actualData',
      label: '',
    },
    currentStep: {
      field: 'currentStep',
      label: '',
    },
    isNextStepDisabled: {
      field: 'isNextStepDisabled',
      label: '',
    },
    isPreviousStepDisabled: {
      field: 'isPreviousStepDisabled',
      label: '',
    },
    errorMessages: {
      field: 'errorMessages',
      label: '',
    },
  },
}
